import React from 'react';

const RoundedPhoto = ({ picture, name, surname, imageSize }) => {
  return (
    <div className="profile-picture" style={{ width: imageSize, height: imageSize }}>
      <img 
        src={picture} 
        alt={`${name} ${surname}`} 
        style={{ 
          width: '100%', 
          height: '100%', 
          borderRadius: '50%', 
          objectFit: 'cover'
        }} 
      />
    </div>
  );
};

export default RoundedPhoto;
